define("ember-cli-string-helpers/helpers/dasherize", ["exports", "@ember/component/helper", "@ember/string", "ember-cli-string-helpers/-private/create-string-helper"], function (_exports, _helper, _string, _createStringHelper) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = _exports.dasherize = void 0;
  const dasherize = _exports.dasherize = (0, _createStringHelper.default)(_string.dasherize);
  var _default = _exports.default = (0, _helper.helper)(dasherize);
});